import { useMainStore } from '~/stores/main';

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const store = useMainStore();

  store.baseUrl = (config.public.baseUrl as string) || store.baseUrl;
  store.baseUrlApi = (config.public.baseUrlApi as string) || store.baseUrlApi;
  store.baseUrlMedia = (config.public.baseUrlMedia as string) || store.baseUrlMedia;

  // Only override when explicitly set: an empty value lets serverInit derive the
  // lang from the host (the production path). A set value wins on localhost,
  // where no host rule matches — useful for testing a specific lang locally.
  if (config.public.lang) {
    store.lang = config.public.lang as string;
  }
});
